import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Alert, Row } from 'reactstrap'
import { extractExpirationInfo } from '../../../lib/util'
import AutoTable from 'components/AutoTable'

const CanceledLicenseGrid = ({ licenses }) => {
  const columns = [
    {
      title: 'License',
      fieldValue: 'id',
    },
    {
      title: 'Sku',
      fieldValue: row => {
        return row.product ? row.product.sku.skuValue : ''
      },
    },
    {
      title: 'Program Codes',
      fieldValue: row => {
        return row.product ? row.product.programCodes.join(', ') : ''
      },
    },
    {
      title: 'Product',
      fieldValue: row => {
        return row.product ? row.product.description : ''
      },
    },
    {
      title: 'School',
      fieldValue: row =>
        row.siteName
          ? row.siteName
          : row.site && row.site.name
          ? row.site.name
          : '',
    },
    {
      title: 'Canceled Date',
      fieldValue: row => {
        if (row.cancelledDate) {
          return extractExpirationInfo(row, 'YYYY-MM-DD').cancelledDate
            .formatted
        } else return 'Active'
      },
    },
  ]

  return licenses.length ? (
    <Row>
      <AutoTable
        borderless
        columns={columns}
        filter
        headThemeLight
        rows={licenses}
        sort
      />
    </Row>
  ) : (
    <Alert color="success">No results found</Alert>
  )
}

CanceledLicenseGrid.propTypes = {
  licenses: PropTypes.arrayOf(PropTypes.object).isRequired,
  onEditLicense: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
}

export default CanceledLicenseGrid



// WEBPACK FOOTER //
// ./src/containers/css-admin/subscriptions/CanceledLicenseGrid.js